import {
  createElementVNode as _createElementVNode,
  openBlock as _openBlock,
  createElementBlock as _createElementBlock,
} from "vue";

export default function render() {
  return (
    _openBlock(),
    _createElementBlock(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 40 40",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
      },
      [
        _createElementVNode("path", {
          "fill-rule": "evenodd",
          d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.95426 31.0457 0 20 0C8.95426 0 0 8.95426 0 20C0 31.0457 8.95426 40 20 40ZM20.4167 15.1388C21.3755 15.1388 22.1528 14.3616 22.1528 13.4029C22.1528 12.4438 21.3755 11.6667 20.4167 11.6667C19.4578 11.6667 18.6805 12.4438 18.6805 13.4029C18.6805 14.3616 19.4578 15.1388 20.4167 15.1388ZM18.3333 19.3054V17.9167H21.1111C21.4946 17.9167 21.8055 18.2275 21.8055 18.6112V26.25H22.5V27.6388H18.3333V26.25H19.0278V19.3054H18.3333Z",
          "clip-rule": "evenodd",
        }),
      ],
    )
  );
}
